// extracted by mini-css-extract-plugin
export default {"tooltip":"UiTooltip_tooltip"};